<template>
  <div class="pop-rule-management">
    <list-block>
      <list-filter
        :form="form"
        @search="handleSearch"
        @reset="handleReset"
      />
    </list-block>
    <list-block>
      <list-table
        :list="list"
        :loading="loading"
        @refresh="fetchData"
      />
      <pagination
        ref="levelRightsPagination"
        :total="total"
        :current-page="page"
        :page-size="size"
        @search="fetchData"
      />
    </list-block>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination/index.vue';
import ListBlock from '@/components/ListBlock/index.vue';
import { popRuleManagementPage } from '@/api/userControl';
import { clearForm } from 'ifs-utils';
import ListFilter from './components/ListFilter.vue';
import ListTable from './components/ListTable.vue';

export default {
  name: 'LevelRights',
  components: {
    Pagination,
    ListBlock,
    ListFilter,
    ListTable,
  },
  data() {
    return {
      total: 0,
      page: 1,
      size: 20,
      loading: false,
      form: {},
      list: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData(page, size) {
      this.loading = true;
      try {
        this.page = page || this.page;
        this.size = size || this.size;
        const data = clearForm({ ...this.form, needUser: true });
        const params = {
          page: this.page,
          size: this.size,
        };
        const resp = await popRuleManagementPage(data, params);
        this.total = resp.total;
        this.list = resp.records;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.page = 1;
      this.$refs.levelRightsPagination.resetPage();
      this.fetchData();
    },
    handleReset() {
      this.form = {};
      this.page = 1;
      this.$refs.levelRightsPagination.resetPage();
      this.fetchData();
    },
  },
};
</script>
<style scoped></style>
